module.exports = __webpack_public_path__ + "media/common/icons/checked-7197837df0761cc469aa20c079a7332a.svg";